import useMountedRef from '@aytm/lib/hooks/useMountedRef'
import { useEffect, useRef, useState } from 'react'

import { ModuleID } from './types'

import ModuleManager from './Module.Manager'

export default function useLoadedModules(moduleIDs: ModuleID[]) {
  const [loaded, setLoaded] = useState(allLoaded(moduleIDs))
  const mountedRef = useMountedRef()
  const loadingRef = useRef(false)

  useEffect(() => {
    if (!loadingRef.current) {
      loadingRef.current = true
      ModuleManager.load(...moduleIDs).then(
        () => {
          if (mountedRef.current) {
            setLoaded(allLoaded(moduleIDs))
          }
        },
        () => {
          //
        }
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, moduleIDs)
  return loaded
}

function allLoaded(moduleIDs: ModuleID[]): boolean {
  return moduleIDs.every(ModuleID => ModuleManager.get(ModuleID).loaded)
}
